module.exports = __webpack_public_path__ + "static/media/5.ec07ee94.jpg";